import { func } from 'validx'

// #region Range

/**
 * Validates that the value is inclusively between the bounds via validx.
 */
export function between(
  inclusiveMin: number,
  inclusiveMax: number,
  message?: string
) {
  const msg =
    message ||
    `The value must be between ${inclusiveMin} and ${inclusiveMax} characters.`

  return func(
    ({ value }) => value >= inclusiveMin && value <= inclusiveMax,
    msg
  )
}

/**
 * Validates that the value is greater than or equal to the specified lower bound
 * via validx.
 */
export function greaterThanOrEqual(lowerBound: number, message?: string) {
  const msg =
    message || `The value must be greater than or equal to ${lowerBound}`

  return func(({ value }) => value >= lowerBound, msg)
}

// #endregion

// #region Length Range

/**
 * Validates that the value has a length inclusively between the bounds specified via validx.
 */
export function lengthBetween(
  inclusiveMin: number,
  inclusiveMax: number,
  message?: string
) {
  const msg =
    message ||
    `The value must be between ${inclusiveMin} and ${inclusiveMax} characters.`

  return func(({ value }) => {
    return value.length >= inclusiveMin && value.length <= inclusiveMax
  }, msg)
}

/**
 * Validates that the value has a length inclusively greater than the bound specified via validx.
 */
export function maxLength(inclusiveMax: number, message?: string) {
  const msg =
    message || `The value can't be greater than ${inclusiveMax} characters.`
  return func(({ value }) => {
    return value.length <= inclusiveMax
  }, msg)
}

/**
 * Validates that the value has a length inclusively less than the bound specified via validx.
 */
export function minLength(inclusiveMin: number, message?: string) {
  const msg =
    message || `The value can't be less than ${inclusiveMin} characters.`
  return func(({ value }) => {
    return value.length >= inclusiveMin
  }, msg)
}

// #endregion

/**
 * Validates all elements in the array where each element implements a `validation`
 * property of type validation context.
 * @param {*} message
 */
export function validateElements(message: string) {
  const msg = message || 'There are invalid elements'

  return func(({ value }) => {
    return (
      value
        .map((v: any) => {
          v.validation.reset()
          return v.validation.validate().isValid
        })
        .every(Boolean) || message
    )
  }, msg)
}
